// extracted by mini-css-extract-plugin
export var statItem = "_gq-1";
export var statsRow = "_gq-0";